import {useMutation} from '@apollo/client'
import {Button, Modal, Spinner, Form} from 'react-bootstrap'
import {CANCEL_POLICY} from '../../../gql/mutations/policyMutation'
import {IResCancelPolicy} from '../soldTypes'
import {parseId} from '../../../helpers'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import { DateInput } from 'app/tfi/components/DateInput'

interface IModalProps {
  id: string
  isOpen: boolean
  onClose: () => void
  refetch: () => void
}

export const ModalCancelPolicy: React.FC<IModalProps> = ({isOpen, onClose, id, refetch}) => {
  const [gqlCancel, {data, loading, error}] = useMutation<IResCancelPolicy>(CANCEL_POLICY)
  const [cancelDate, setCancelDate] = useState<string>('')

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return

    if (data.cancelPolicy.success) {
      toast.success('Policy canceled successfully')
      refetch()
      onClose()
    } else if (data.cancelPolicy.errors && data.cancelPolicy.errors.length > 0) {
      toast.error(`Error ${data.cancelPolicy.errors[0].message}`)
    }
  }, [data])

  const handleDelete = () => {
    console.log('handleDelete called, cancelDate value:', cancelDate)

    // Si no hay fecha, se enviará undefined y el backend usará la fecha actual
    const variables: { id: string | number; cancellationDate?: string } = {
      id: parseId(id),
    }

    if (cancelDate) {
      variables.cancellationDate = cancelDate
    }

    console.log('Sending mutation with variables:', variables)
    gqlCancel({ variables })
  }

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Mark this policy as canceled?</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className='d-flex align-items-start mb-3'>
          <i className='bi bi-exclamation-triangle-fill text-danger fs-2 me-3'></i>
          <div>
            <p className='fw-semibold'>
              Clicking <strong>'Yes, cancel it!'</strong> will set the status of the policy as
              <strong> canceled </strong> and include it in the following commissions report as a canceled policy.
            </p>
          </div>
        </div>

        <Form.Group>
          <Form.Label className='fw-bold'>
            Cancellation Date <span className='text-muted'>(optional - defaults to today)</span>
          </Form.Label>
          <DateInput
            id="cancelDate"
            name="cancelDate"
            value={cancelDate}
            onChange={(_field: string, val: string | null) => {
              console.log('DateInput changed, raw value:', val)
              setCancelDate(val || '')
            }}
            required={false}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='danger' onClick={handleDelete} disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />}
          Yes, cancel it!
        </Button>
      </Modal.Footer>
    </Modal>
  )
}